import Forms from 'components/Forms';
import { CustomerType } from 'store/modules/Customers/types';
import { ChargeType } from 'store/modules/ExistingPolicies/types';
import { formatCurrency } from 'utils';
import { prepareFunds, prepareMpCharges } from './ManagePolicies';

const createPolicyArray = (
  policies: any,
  customers: CustomerType[],
  chargeTypes: any
) => [
  ...policies.map((policy: any) => {
    if (!policy.owner) {
      return {
        id: policy.id,
        owner: customers.length === 1 ? customers[0].id : null,
        platform: null,
        wrap_amount: null,
        provider: null,
        type: null,
        number: null,
        settings: {
          chargesAllowPercentage: false,
          fundsAllowPercentage: false
        },
        fund_value: '',
        is_processed: false,
        transfer_value: '',
        fund_allocations: [],
        charges: Forms.Utils.prepareCharges({
          initialValues: [],
          chargeTypes
        }),
        model_portfolio_charges: []
      };
    }
    if (policy.owner) {
      return {
        ...policy,
        id: policy.id,
        owner: Number(policy.owner.id) || policy.owner,
        platform: policy.platform || '',
        provider: policy.provider,
        wrap_amount: policy.wrap_amount,
        type: policy.type,
        is_processed: policy.is_processed,
        number: policy.number,
        fund_value: formatCurrency(policy.fund_value),
        transfer_value: formatCurrency(policy.transfer_value),
        settings: {
          chargesAllowPercentage: !(
            policy.charges[0] && policy.charges[0].cash_value
          ),
          fundsAllowPercentage: !(
            policy.fund_allocations[0] && policy.fund_allocations[0].fund_value
          )
        },
        fund_allocations: prepareFunds(
          policy.wrap_amount,
          policy.fund_allocations
        ),
        charges: Forms.Utils.prepareCharges({
          initialValues: policy.charges,
          chargeTypes: chargeTypes
        }),
        aggregateOcfCharge: policy.charges.filter(
          (charge: ChargeType) => charge.kind === 1
        )[0],
        aggregateFundCharge: policy.charges.filter(
          (charge: ChargeType) => charge.kind === 2
        )[0],
        model_portfolio_charges: prepareMpCharges(policy.fund_allocations)
      };
    } else return policy;
  })
];

export default createPolicyArray;
